import React, { FC } from 'react'

export const InvalidRolePage:FC = () => {
  return (
    <h2>invalid_role</h2>
  )
}